var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavIncidencias = function SvgNavIncidencias(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_incidencias_svg__Capa_2",
    viewBox: "0 0 34.05 33.42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_incidencias_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.46 25.12c-.33-.33-.49-.73-.49-1.21s.16-.88.49-1.21.73-.49 1.21-.49.85.16 1.17.49.48.73.48 1.21-.16.88-.48 1.21-.71.49-1.17.49-.88-.16-1.21-.49Zm2.53-13.95-.3 7.13H15.6l-.3-7.13z",
    stroke: "#2ad2c5",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94 32.67h16.17c6.17 0 10.12-6.58 7.22-12.03L24.04 5.08C20.93-.76 12.52-.68 9.53 5.23L1.64 20.79c-2.76 5.44 1.2 11.87 7.3 11.87Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    stroke: "#b3b3b3"
  }))));
};
export default SvgNavIncidencias;